import React from 'react';
import Relay from 'react-relay';
import mergeWith from 'lodash/mergeWith'
import pickBy from 'lodash/pickBy'

import Button from '../../components/Button';
import VenueTable from '../../components/VenueTable';
import { isValidEmailAddress } from '../../components/UserPanel';

import UpdateUserMutation from '../../mutations/User/UpdateUserMutation';

const pageSize = 100;

class VenuesList extends React.Component {

  state = {
    search: '',
    loading: false,
  }

  constructor(props) {
    super(props);
  }

  componentWillMount(){
    this.componentWillReceiveProps(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.loading) return false

    const existFirst = (objValue, srcValue) => objValue? objValue : srcValue
    const propsWithDefaults = mergeWith(nextProps, this.state, existFirst)
    const { search /*, searchByUserType, searchBySportId, searchBySportLevel*/ } = propsWithDefaults
    this.hasNextPage = nextProps.viewer.next ? nextProps.viewer.next.pageInfo.hasPreviousPage : this.hasNextPage;
    this.hasPreviousPage = nextProps.viewer.prev ? nextProps.viewer.prev.pageInfo.hasNextPage : this.hasPreviousPage;

    const variables = {}

    if (Object.keys(variables).length) {
      this.setState({
        loading: true,
      })
      this.props.relay.setVariables(variables, (state) =>
        (state.done || state.aborted) && this.setState({
          loading: false,
        })
      )
    }
  }

  nextPage() {
    this.hasPreviousPage = true;
    const pageInfo = this.props.viewer.next ? this.props.viewer.next.pageInfo : this.props.viewer.prev.pageInfo;
    const cursor = pageInfo.startCursor;
    this.setState({ loading: true })
    this.props.relay.setVariables({
      before: cursor,
      next: true,
      prev: false
    }, ({ done, aborted }) => (done || aborted) && this.setState({ loading: false }));
  }

  prevPage() {
    this.hasNextPage = true;
    const pageInfo = this.props.viewer.next ? this.props.viewer.next.pageInfo : this.props.viewer.prev.pageInfo;
    const cursor = pageInfo.endCursor;
    this.setState({ loading: true })
    this.props.relay.setVariables({
      after: cursor,
      next: false,
      prev: true
    }, ({ done, aborted }) => (done || aborted) && this.setState({ loading: false }));
  }

  assetEdges() {
    // get the next edges or the prev edges, or just get an empty array
    return (this.props.viewer ?
      (this.props.viewer.next ? this.props.viewer.next.edges :
        (this.props.viewer.prev ? this.props.viewer.prev.edges : []))
      : [])
  }

  onEditVenueClick = (item, index) => {
    if(item == this.props.location.state.user){
      return;
    }

    let path = '/venues/edit/'+item.id;
    this.props.router.push({
      pathname : path,
      state: {
          venueId:item.id,
      }
    })
  }

  render() {
    if (this.state.loading) return (<div>Loading...</div>)

    const prevButton = this.hasPreviousPage ? <button onClick={ this.prevPage.bind(this) }>Prev</button> : '';
    const nextButton = this.hasNextPage ? <button onClick={ this.nextPage.bind(this) }>Next</button> : '';

    const venues = this.assetEdges();
    let filter = this.props.location.state.filter;

    return (
      <div>
         <VenueTable
          dataSource={venues}
          filter={filter}
          onItemClick={this.onEditVenueClick}
        />
        {this.props.children}
        { prevButton } { nextButton }
      </div>
    );

  }

}

VenuesList.propTypes = ({
  viewer: React.PropTypes.object.isRequired,
  relay: React.PropTypes.object.isRequired,
  children: React.PropTypes.node,
});

export default Relay.createContainer(VenuesList, {
  initialVariables: {
    // filter: null,
    first: pageSize,
    last: pageSize,
    after: null,
    before: null,
    next: true,
    prev: false,
    // pseudo: null,
    // email: null,
    // sport: null,
    // userType: null,
  },

  fragments: {
      viewer: () => Relay.QL`
          fragment on Viewer {
              next: venues(last: $last, before: $before) @include(if: $next) {
                  edges {
                      node {
                          id,
                          name,
                          address {
                            address,
                            city, 
                            zip, 
                            country
                          }
                          infrastructures {
                            id
                          }
                      }
                  }
                  pageInfo {
                      hasNextPage
                      hasPreviousPage
                      startCursor
                      endCursor
                  }
              }
              prev: venues(first: $first, after: $after) @include(if: $prev) {
                  edges {
                      node {
                          id,
                          name,
                          address {
                            address,
                            city, 
                            zip, 
                            country
                          }
                          infrastructures {
                            id
                          }
                      }
                  }
                  pageInfo {
                      hasNextPage
                      hasPreviousPage
                      startCursor
                      endCursor
                  }
              }
          }
      `,
    }
});



// WEBPACK FOOTER //
// ./src/pages/Venue/VenueList.js